import React from 'react'

const KnowledgeBank = () => {
  return (
    <div>KnowledgeBank</div>
  )
}

export default KnowledgeBank